import { v4 as uuidv4 } from 'uuid';

// Template for persistent data
const template = {
    guid: null,
    cookies: false,
    treatment: null,
    customer: {
        firstname: null,
        lastname: null,
        email: null,
        telephone: null
    }
};

// Load existing persistent data or create new with generated GUID
const storedData = localStorage.getItem('persistent');
let value;

if (storedData) {
    // Load existing data, merge with template
    value = Object.assign({}, template, JSON.parse(storedData));
} else {
    // Create new persistent data with generated GUID
    value = Object.assign({}, template, { guid: uuidv4() });
    // Store immediately since effect might not catch initial creation
    localStorage.setItem('persistent', JSON.stringify(value));
}

const persistent = $state(value);

$effect.root(() => {
    $effect(() => {
        const snapshot = $state.snapshot(persistent);
        localStorage.setItem('persistent', JSON.stringify(snapshot));
    });
});

export default persistent;